import React from 'react';
import '../../../../sass/apps/contact/advertiser_details.scss';

const AdvertiserDetails = ({ profilePhotoUrl, advert, localisations }) => (
  <React.Fragment>
    <div className="advertiser-details">
      <div className="advertiser-details__details">
        <img
          src={profilePhotoUrl}
          alt={localisations.advertisers_profile_photo}
          className="advertiser-details__photo"
        />
        <div className="advertiser-details__advert-title">
          <span>RE: {advert.title}</span>
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default AdvertiserDetails;
